// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"249":"f54d50eb6b4af734","698":"630132ab6bebe8f0"}[chunkId] + ".js";
};